import { REDUX_LOCAL_KEY } from '../../../redux/constants/local-key'

const WORKOUT_CLASS_NAME = 'Workout'

const WORKOUT_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className',

  DURATION: 'duration',
  NAME: 'name',
  LEVEL: 'level',
  TYPES: 'types',
  EQUIPMENT: 'equipment',
  MUSCLES: 'muscles',
  SECONDARY_MUSCLES: 'secondaryMuscles',
  COMPLETION_TIME: 'completionTime',
  FEATURED_AT: 'featuredAt',
  RECOMMENDED_AT: 'recommendedAt',
  TRENDING_AT: 'trendingAt',

  ESTIMATED_METABOLIC_EQUIVALENT: 'estimatedMetabolicEquivalent',
  ESTIMATED_CALORIES: 'estimatedCalories',
  METABOLIC_EQUIVALENT: 'metabolicEquivalent',
  CALORIES: 'calories',
  ESTIMATED_TRAINING_VOLUME: 'estimatedTrainingVolume',
  TRAINING_VOLUME: 'trainingVolume',

  LOGGED_AT: 'loggedAt',
  STARTED_AT: 'startedAt',
  PLANNED_AT: 'plannedAt',
  SUGGESTED_AT: 'suggestedAt',
  DIFFICULTY: 'difficulty',
  NOTES: 'notes',
  INSTRUCTIONS: 'instructions',
  IMAGE: 'image',
  RATING: 'rating',
  REVIEW_COUNT: 'reviewCount',
  COMPLETED_COUNT: 'completedCount',
  STARTED_COUNT: 'startedCount',

  SHARE_KEY: 'shareKey',

  // Associations
  PARENT: 'parent',
  RECOMMENDED: 'recommended',
  WORKOUT_SECTIONS: 'workoutSections',
  EXERCISE_LOGS: 'exerciseLogs',
  TAGS: 'tags',
  MEDIA: 'media',

  // Foreign keys
  PROFILE_ID: 'profileId',
  AUTHOR_ID: 'authorId',
  PLAN_ID: 'planId',
  PARENT_ID: 'parentId',
  ORIGINAL_PARENT_ID: 'originalParentId',
  MEDIA_ID: 'mediaId',

  // Local -- not understood by the server
  LOCAL_HAS_ASSOCIATION_CHANGE: REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE,
  LOCAL_IS_DOWNLOADED: REDUX_LOCAL_KEY.IS_DOWNLOADED,
  LOCAL_IS_SUGGESTED: REDUX_LOCAL_KEY.IS_SUGGESTED,
  LOCAL_IS_REORDERING_WORKOUT_SECTIONS: '__localIsReorderingWorkoutSections',
  LOCAL_IS_REORDERING_WORKOUT_EXERCISES: '__localIsReorderingWorkoutExercises',
  LOCAL_IS_REORDERING_WORKOUT_EXERCISE_SETS: '__localIsReorderingWorkoutExerciseSets',
  LOCAL_ACTIVITY: '__localActivity',
  LOCAL_HAS_SUGGESTED_TO_COPY_FROM_WORKOUT_LOCAL: '__localHasSuggestedToCopyFromWorkoutLocal',

  PROFILES_WHO_STARTED: 'profilesWhoStarted'
}

export { WORKOUT_KEY }

export { WORKOUT_CLASS_NAME }

const WORKOUT_ASSOCIATION_KEYS = [
  WORKOUT_KEY.EXERCISE_LOGS,
  WORKOUT_KEY.TAGS,
  WORKOUT_KEY.WORKOUT_SECTIONS,
  WORKOUT_KEY.PROFILES_WHO_STARTED,
  WORKOUT_KEY.MEDIA
]

export { WORKOUT_ASSOCIATION_KEYS }
// import { WORKOUT_KEY } from './constants/workout/key'

const WORKOUT_PRIVATE_KEYS = []

export { WORKOUT_PRIVATE_KEYS }

const WORKOUT_SCOPE = {

  /**
   * Only returns the public attributes.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: WORKOUT_PRIVATE_KEYS
    }
  }

}

export { WORKOUT_SCOPE }
const TYPE = {
  STRENGTH: 1,
  HYPERTROPHY: 2,
  ENDURANCE: 3,
  CARDIO: 4,
  STRETCHING: 5
}

export { TYPE }
//
// const WORKOUT_FOREIGN_KEYS = [
//   WORKOUT_KEY.AUTHOR_ID,
//   WORKOUT_KEY.PROFILE_ID,
//   WORKOUT_KEY.PLAN_ID,
//   WORKOUT_KEY.ORIGINAL_PARENT_ID,
//   WORKOUT_KEY.PARENT_ID
// ]

// export { WORKOUT_FOREIGN_KEYS }
const WORKOUT_AUDIT = {
  CREATED: 'Workout Created',
  DELETED: 'Workout Deleted',
  UPDATED: 'Workout Updated',
  REGENERATED: 'Workout Regenerated',
  SHARED: 'Workout Shared',
  LOGGED: 'Workout Logged'
}

export { WORKOUT_AUDIT }

export const WORKOUT_SHALLOW_KEYS = [
  WORKOUT_KEY.NAME,
  WORKOUT_KEY.LEVEL,
  WORKOUT_KEY.DURATION,
  WORKOUT_KEY.IMAGE,
  WORKOUT_KEY.COMPLETION_TIME
]

export const WORKOUT_LOCAL_KEYS = [
  REDUX_LOCAL_KEY.IS_DOWNLOADED,
  REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE,
  WORKOUT_KEY.LOCAL_IS_SUGGESTED,
  WORKOUT_KEY.LOCAL_IS_REORDERING_WORKOUT_SECTIONS,
  WORKOUT_KEY.LOCAL_IS_REORDERING_WORKOUT_EXERCISES
]
